import React from "react";
import {Control, PathValue} from "react-hook-form/dist/types";
import {AziendaRecord} from "@commons/mapping/AziendaRecord";
import {Controller, FieldPath, Path} from "react-hook-form";
import ComboBox from "./ComboBox";
import {FieldValues} from "react-hook-form/dist/types/fields";
import {RegisterOptions} from "react-hook-form/dist/types/validator";

export function ComboBoxAziende<T extends FieldValues>({
                                                           control,
                                                           name,
                                                           defaultValue,
                                                           label,
                                                           data,
                                                           rules = {required: true},
                                                           isLoading,
                                                           displayValueFn = (v: AziendaRecord, elenco?: AziendaRecord[]) => elenco && v ? v.descrizione! : ''
                                                       }: {
    control: Control<T>,
    name: FieldPath<T>,
    defaultValue: PathValue<T, Path<T>>,
    label: string,
    data?: AziendaRecord[],
    rules?: Omit<RegisterOptions<T, Path<T>>, "valueAsNumber" | "valueAsDate" | "setValueAs" | "disabled"> | undefined,
    isLoading?: boolean,
    displayValueFn?: (v: AziendaRecord, elenco?: AziendaRecord[]) => string
}) {
    return <Controller name={name}
                       control={control}
                       defaultValue={defaultValue}
                       rules={rules}
                       render={({field: {value, onChange}, fieldState}) => {
                           return (
                               <ComboBox<AziendaRecord> label={label} value={{idAzienda: value}} onChange={(value) => {
                                   onChange(value?.idAzienda)
                               }} fieldState={fieldState}
                                                        data={data}
                                                        isLoading={isLoading}
                                                        searchablePropsName={["unitaLocale", "descrizione"]}
                                                        isSameFn={(a, z) => (a && z) ? a.idAzienda === z.idAzienda : false}
                                                        keyValueFn={(v) => v.idAzienda!}
                                                        displayValueFn={(v) => displayValueFn(v, data)}
                               />
                           )
                       }}
    />
}

export default ComboBoxAziende;